import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a destination icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DestinationIcon width={12} />
 */
const DestinationIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M3.936 4.571c-0.7 0-1.269 0.569-1.269
            1.268v21.59h2.539v-21.59c0-0.699-0.568-1.268-1.269-1.268z`}
        />
        <path
            d={`M28.065 4.571c-0.701 0-1.269 0.569-1.269
            1.268v21.59h2.539v-21.59c0-0.699-0.569-1.268-1.269-1.268z`}
        />
        <path d="M6.476 7.111h3.808v3.808h-3.808v-3.808z" />
        <path d="M10.286 10.919h3.809v3.808h-3.809v-3.808z" />
        <path d="M14.095 7.111h3.809v3.808h-3.809v-3.808z" />
        <path d="M6.476 14.729h3.808v3.81h-3.808v-3.809z" />
        <path d="M14.095 14.729h3.809v3.81h-3.809v-3.809z" />
        <path d="M17.906 10.919h3.809v3.808h-3.809v-3.808z" />
        <path d="M21.716 7.111h3.808v3.808h-3.808v-3.808z" />
        <path d="M21.716 14.729h3.808v3.81h-3.808v-3.809z" />
    </SvgIcon>
)

DestinationIcon.defaultProps = defaultProps

export { DestinationIcon }
